module.exports = __webpack_public_path__ + "img/Billing.b97ff4d9.svg";